import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LoButton, LoIcon, LoStatus } from 'lo-design-system';
import {
	ConnectionSource,
	InstagramCredentialDetails,
	InstagramCredentialType
} from '@brand-lolly/app/_models/brand-instagram-integration.model';

@Component({
	standalone: true,
	selector: 'meta-credentials-list',
	imports: [LoButton, LoIcon, LoStatus],
	template: `
		<div class="cred-row">
			<lo-icon name="facebook_logo" [size]="20" />
			<span class="name lo-type-text-sm-semibold">Facebook OAuth</span>
			<span class="meta lo-type-text-xs">
				{{ hasFacebook ? metaForType('facebook_oauth') : '—' }}
			</span>
			<lo-status [tone]="hasFacebook ? 'success' : 'neutral'">
				{{ hasFacebook ? 'Connected' : 'Not connected' }}
			</lo-status>
		</div>
		<div class="cred-row">
			<lo-icon name="instagram_logo" [size]="20" />
			<span class="name lo-type-text-sm-semibold">Instagram OAuth</span>
			<span class="meta lo-type-text-xs">
				{{ hasInstagram ? metaForType('instagram_oauth') : '—' }}
			</span>
			<lo-status [tone]="hasInstagram ? 'success' : 'neutral'">
				{{ hasInstagram ? 'Connected' : 'Not connected' }}
			</lo-status>
		</div>
		<div class="cred-row">
			<lo-icon name="lock" [size]="20" />
			<span class="name lo-type-text-sm-semibold">Password + 2FA</span>
			<lo-status [tone]="hasPassword ? 'success' : 'danger'">
				{{ hasPassword ? 'Configured' : 'Required for DM' }}
			</lo-status>
			@if (!hasPassword) {
				<button
					lo-button
					variant="secondary"
					size="sm"
					type="button"
					(click)="addPassword.emit()"
				>
					Add
				</button>
			}
		</div>
	`,
	styles: [
		`
			:host {
				display: flex;
				flex-direction: column;
				gap: var(--lo-space-gap-md);

				.cred-row {
					display: flex;
					align-items: center;
					gap: var(--lo-space-gap-md);

					.name {
						flex: 1;
					}

					.meta {
						color: var(--lo-color-text-secondary);
					}
				}
			}
		`
	]
})
export class MetaCredentialsListComponent {
	@Input() credentials: InstagramCredentialDetails[] = [];
	@Input() connectionSources: ConnectionSource[] = [];

	@Output() addPassword = new EventEmitter<void>();

	get hasFacebook(): boolean {
		return this.connectionSources.includes('facebook_oauth');
	}

	get hasInstagram(): boolean {
		return this.connectionSources.includes('instagram_oauth');
	}

	get hasPassword(): boolean {
		return this.connectionSources.includes('password');
	}

	metaForType(type: InstagramCredentialType): string {
		const credential = this.credentials.find(c => c.type === type);
		if (credential?.expires_at) {
			const date = new Date(credential.expires_at);
			return `expires ${date.toLocaleDateString()}`;
		}
		return 'refreshed today';
	}
}
